/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Sovereign_Dispute_ResolutionInputs */

const en_sovereign_dispute_resolution = /** @type {(inputs: Sovereign_Dispute_ResolutionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Dispute resolution guarantee`)
};

const id_sovereign_dispute_resolution = /** @type {(inputs: Sovereign_Dispute_ResolutionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Jaminan penyelesaian sengketa`)
};

/** @type {(inputs: Sovereign_Dispute_ResolutionInputs) => LocalizedString} */
const es_sovereign_dispute_resolution = en_sovereign_dispute_resolution;

/** @type {(inputs: Sovereign_Dispute_ResolutionInputs) => LocalizedString} */
const fr_sovereign_dispute_resolution = en_sovereign_dispute_resolution;

/** @type {(inputs: Sovereign_Dispute_ResolutionInputs) => LocalizedString} */
const de_sovereign_dispute_resolution = en_sovereign_dispute_resolution;

/** @type {(inputs: Sovereign_Dispute_ResolutionInputs) => LocalizedString} */
const ja_sovereign_dispute_resolution = en_sovereign_dispute_resolution;

/** @type {(inputs: Sovereign_Dispute_ResolutionInputs) => LocalizedString} */
const zh_sovereign_dispute_resolution = en_sovereign_dispute_resolution;

/** @type {(inputs: Sovereign_Dispute_ResolutionInputs) => LocalizedString} */
const ar_sovereign_dispute_resolution = en_sovereign_dispute_resolution;

/** @type {(inputs: Sovereign_Dispute_ResolutionInputs) => LocalizedString} */
const it_sovereign_dispute_resolution = en_sovereign_dispute_resolution;

/** @type {(inputs: Sovereign_Dispute_ResolutionInputs) => LocalizedString} */
const ru_sovereign_dispute_resolution = en_sovereign_dispute_resolution;

/** @type {(inputs: Sovereign_Dispute_ResolutionInputs) => LocalizedString} */
const pt_sovereign_dispute_resolution = en_sovereign_dispute_resolution;

/** @type {(inputs: Sovereign_Dispute_ResolutionInputs) => LocalizedString} */
const ko_sovereign_dispute_resolution = en_sovereign_dispute_resolution;

/**
* | output |
* | --- |
* | "Dispute resolution guarantee" |
*
* @param {Sovereign_Dispute_ResolutionInputs} inputs
* @param {{ locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }} options
* @returns {LocalizedString}
*/
export const sovereign_dispute_resolution = /** @type {((inputs?: Sovereign_Dispute_ResolutionInputs, options?: { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Sovereign_Dispute_ResolutionInputs, { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_sovereign_dispute_resolution(inputs)
	if (locale === "es") return es_sovereign_dispute_resolution(inputs)
	if (locale === "fr") return fr_sovereign_dispute_resolution(inputs)
	if (locale === "de") return de_sovereign_dispute_resolution(inputs)
	if (locale === "ja") return ja_sovereign_dispute_resolution(inputs)
	if (locale === "zh") return zh_sovereign_dispute_resolution(inputs)
	if (locale === "ar") return ar_sovereign_dispute_resolution(inputs)
	if (locale === "id") return id_sovereign_dispute_resolution(inputs)
	if (locale === "it") return it_sovereign_dispute_resolution(inputs)
	if (locale === "ru") return ru_sovereign_dispute_resolution(inputs)
	if (locale === "pt") return pt_sovereign_dispute_resolution(inputs)
	return ko_sovereign_dispute_resolution(inputs)
});